import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
import { isWHW, isWHWP2 } from '../../components/common/Helpers/index';

export const getDataFromApi = (data) => ({
  type: Constants.GET_DATA_FROM_API,
  data,
});

export const getData = () => HttpService.get(`${getSecureBaseUrl()}${apiUrls().appointmenturl}`);

// for calling app schedule api
export const getAppSchedule = (data) => ({
  type: Constants.GET_DATA_FROM_APP_SCHEDULE,
  data,
});

export const emailVaildationAppointmentAPI = (email, id) => ({
  type: Constants.EMAIL_VALIDATION_APPOINTMENT_API,
  data: { email, id },
});

export const accMainEmailAppointmentVerify = (data) => ({
  type: Constants.ACCOUNT_MAINTENENCE_APPOINTMENT_EMAIL_VERIFICATION,
  data,
});

// update selfInstallation call
export const postSelfInstallation = (data) => ({
  type: Constants.POST_DATA_SELF_INSTALLATION,
  data,
});

// saveSelfDate
export const saveSelfInstallDate = (data) => ({
  type: 'SAVE_SELF_INSTALL_DATE',
  data,
});

export const postProInstallation = (data, payload) => ({
  type: Constants.POST_DATA_PRO_INSTALLATION,
  data,
  payload,
});

export const postSelf = (data) => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateSelfInstallation}`;
  return HttpService.post(apiURL, data);
};

export const postPro = (data) => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateProInstallation}`;
  return HttpService.post(apiURL, data);
};

export const getSchedule = () => {
  // data) => {
  // constructing current Date
  let date = new Date();
  const year = date.getFullYear();

  let month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : `0${month}`;

  let day = date.getDate().toString();
  day = day.length > 1 ? day : `0${day}`;

  date = `${month}/${day}/${year}`;
  // alert(date);

  const reqt = {
    startDate: date,
    numberOfDays: 30,
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().get5GProAppointments}`;
  return HttpService.post(apiURL, reqt);
};

export const callSubmitOrder = (data) => ({
  type: Constants.SUBMIT_ORDER,
  data,
});

export const getSubmitOrder = () => {
  const postData = {
    locationCode: '',
    accountNumber: '',
    mtn: '',
    intent: `${(isWHW() || isWHWP2()) ? 'RedemptionAccessory' : ''}`,
    cartCreator: '',
    smsDestination: '',
    email: '',
    enforceData: {
      screenResolution: {
        availableWidth: 1920,
        availableHeight: 1040,
        actualWidth: 1920,
        actualHeight: 1080,
        pixelDensity: 24,
      },
      touchSupport: 'Y',
      cookieStatus: 'enabled',
      visitorId: '',
      listOfMimeTypes: ['application/pdf', 'application/x-google-chrome-pdf', 'application/x-nacl', 'application/x-pnacl'],
    },
    sddShipmentInfo: [],
    expressCheckout: 'false',
  };
  // return new Promise((resolve, reject) => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().submitOrder}`;
  return HttpService.post(apiURL, postData);
};

export const appointmentCTA = (data) => ({
  type: 'APPOINTMENT_CTA',
  data,
});

export const saveSelectedDate = (dateR, dayR) => ({
  type: 'SAVE_SELECTED_DATE',
  dateR,
  dayR,
});

export const saveSelectedSlot = (slot) => ({
  type: 'SAVE_SELECTED_SLOT',
  slot,
});

export const saveReminderType = (reminderType) => ({
  type: 'SAVE_REMINDER_TYPE',
  reminderType,
});

export const saveEmailId = (email, CTAdisabled) => ({
  type: 'SAVE_EMAIL_ID',
  email,
  CTAdisabled,
});
export const savePhoneNumber = (phoneNo, CTAdisabled) => ({
  type: 'SAVE_PHONE_NO',
  phoneNo,
  CTAdisabled,
});
export const proSetupValidation = (isValidProSetupData) => ({
  type: 'SAVE_IS_VALID_PRO_SETUP_DATA',
  isValidProSetupData,
});
export const saveSpecInstrc = (specInst) => ({
  type: 'SAVE_SPEC_INSTRC',
  specInst,
});
export const saveCTAdisabled = (CTAdisabled) => ({
  type: 'SAVE_CTAdisabled',
  CTAdisabled,
});
// export const getDataFromApi = (data) => ({
//   type: Constants.GET_DATA_FROM_API,
//   data,
// });

export const updateAppointmentFlag = (data) => ({
  type: 'UPDATE_APPOINTMENT_SUCCESS',
  data,
});
